import { BaseModel } from './BaseInterface';
export const RiskToleranceBase: BaseModel[] = [
  {
    key: 'veryLow',
    userInput: 'Very Low',
    apiValue: 1,
    dbValue: 1,
    score: 20
  },
  {
    key: 'low',
    userInput: 'Low',
    apiValue: 2,
    dbValue: 2,
    score: 40
  },
  {
    key: 'moderate',
    userInput: 'Moderate',
    apiValue: 3,
    dbValue: 3,
    score: 60
  },
  {
    key: 'high',
    userInput: 'High',
    apiValue: 4,
    dbValue: 4,
    score: 80
  },
  {
    key: 'veryHigh',
    userInput: 'Very High',
    apiValue: 5,
    dbValue: 5,
    score: 100
  }
];
